export const REGISTER_REPRESENTANTE_REQUEST ="REGISTER_REPRESENTANTE_REQUEST";
export const REGISTER_REPRESENTANTE_FAIL = "REGISTER_REPRESENTANTE_FAIL";
export const REGISTER_REPRESENTANTE_SUCCESS ="REGISTER_REPRESENTANTE_SUCCESS";
export const USER_REGISTER_CONTACTO_REQUEST = "USER_REGISTER_CONTACTO_REQUEST";
export const USER_REGISTER_CONTACTO_SUCCESS = "USER_REGISTER_CONTACTO_SUCCESS";
export const USER_REGISTER_CONTACTO_FAIL = " USER_REGISTER_CONTACTO_FAIL";
export const FETCH_PROJECTS = "FETCH_PROJECTS";